// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__7lix6","emails":"CreateEditClinics_emails__3AV26","emailTagLabel":"CreateEditClinics_emailTagLabel__2sAic"};